import { useQuery } from 'react-query';
import PlaylistsApi from './api';

export function usePlaylists(enabled = true) {
  return useQuery(['playlists'], () => PlaylistsApi.list(), {
    enabled,
    staleTime: 60_000,
  });
}
